import { Injectable } from '@angular/core'

import * as _ from 'lodash'

import { PageResultDto, ProductDto, FindProductDto, ProductDetailDto, CreateOrUpdateProductDto, SetFileDto, SetFilesDto, ResultDto } from './../dto'
import { HttpService } from './http.service'
import { CreateOrUpdateProductV2Dto, FindProductDefaultDto } from '../dto/product.dto'
import { ResultSyncDto } from '../dto/result.dto'

@Injectable()
export class ProductService {
  constructor(
    private httpService: HttpService
  ) {
  }

  async findClientProduct(findProductDto: FindProductDto) {
    return await this.httpService.get<PageResultDto<ProductDto>>(`/merchant/v1/products/clients`, findProductDto)
  }

  async syncProduct() {
    return await this.httpService.get<ResultSyncDto>('/merchant/v1/products/synced')
  }

  async forceSynced() {
    return await this.httpService.post<boolean>('/merchant/v1/products/synced')
  }


  async findAllProduct(discounted: string) {
    return await this.httpService.get<ProductDto[]>(`/merchant/v1/products`, { discounted })
  }

  async findProductDefault(findProductDefaultDto: FindProductDefaultDto) {
    return await this.httpService.get<PageResultDto<ProductDto>>(`/merchant/v1/products/section-default`, findProductDefaultDto)
  }

  async findAllClientProduct(discounted: string) {
    return await this.httpService.get<PageResultDto<ProductDto[]>>(`/merchant/v1/products`, { discounted })
  }

  async createOrUpdate(createOrUpdateProductDto: CreateOrUpdateProductDto[]) {
    return await this.httpService.put<ProductDto>(`/merchant/v1/products`, createOrUpdateProductDto)
  }

  async createOrUpdateV2(productId: string, createOrUpdateProductDto: CreateOrUpdateProductV2Dto) {
    return await this.httpService.put<ProductDto>(`/merchant/v1/products/v2/${productId}`, createOrUpdateProductDto)
  }

  async find(findProductDto: FindProductDto) {
    return await this.httpService.get<PageResultDto<ProductDto>>(`/merchant/v1/products`, findProductDto)
  }

  async publish(id: string) {
    return await this.httpService.post(`/merchant/v1/products/${id}/publish`)
  }

  async findOne(id: string) {
    return await this.httpService.get<ProductDetailDto>(`/merchant/v1/products/${id}`)
  }

  async deleteOne(id: string) {
    return await this.httpService.delete<Boolean>(`/merchant/v1/products/${id}`)
  }

  async setThumbnail(productId: string, setFileDto: SetFileDto) {
    return await this.httpService.put<ProductDetailDto>(`/merchant/v1/products/${productId}/thumbnail`, setFileDto)
  }

  async setResizedThumbnail(productId: string, setFileDto: SetFileDto) {
    return await this.httpService.put<ProductDetailDto>(`/merchant/v1/products/${productId}/resized-thumbnail`, setFileDto)
  }

  async setColorThumbnail(productId: string, setFileDto: SetFileDto) {
    return await this.httpService.put<ProductDetailDto>(`/merchant/v1/products/${productId}/color-thumbnail`, setFileDto)
  }

  async setImages(productId: string, setFilesDto: SetFilesDto) {
    return await this.httpService.put<ProductDetailDto>(`/merchant/v1/products/${productId}/images`, setFilesDto)
  }

  async setSpecsImage(productId: string, setFilesDto: SetFilesDto) {
    return await this.httpService.put<ProductDetailDto>(`/merchant/v1/products/${productId}/specs-images`, setFilesDto)
  }

  async setEnabled(id: string, enabled: boolean) {
    if (enabled) {
      return await this.httpService.put<Boolean>(`/merchant/v1/products/${id}/enable`)
    }

    return await this.httpService.put<Boolean>(`/merchant/v1/products/${id}/disable`)
  }
}
